import api from '../../schedulerApi';

const useHttpPutDailyBlueprint = () => {
    const update = async (blueprint_id, slots, name = 'updated') => {
        try {
            const response = await api.update_daily_blueprint(blueprint_id, slots, name);
            return response;
        } catch (error) {
            console.error('Error updating daily blueprint:', error?.response?.data || error.message);
            throw error;
        }
    };

    return update;
};

export default useHttpPutDailyBlueprint;
